import { useCallback } from 'react';
import { isWithinInterval } from 'date-fns';
import classNames from 'classnames';
import { Button } from 'app/agriculture/components/Button/Button';
import {
    useTimelineDispatch,
    useTimelineInterval,
    useTimelineViewMode,
} from 'app/agriculture/AgTimeline/context/TimelineContext';
import { useThrottledNow } from 'app/agriculture/AgTimeline/hooks/useThrottledNow';
import './TimelineNowIndicator.scss';
import { percentageOfInterval } from 'app/agriculture/AgTimeline/utils/percentageOfInterval';

export function TimelineNowIndicator() {
    const throttledNow = useThrottledNow();
    const timelineInterval = useTimelineInterval();
    const { setInterval, setCursorTime } = useTimelineDispatch();
    const { getNewVisibleInterval } = useTimelineViewMode();

    const handleGoToNowClick = useCallback(() => {
        setInterval(getNewVisibleInterval(throttledNow), { cursorTime: null });
    }, [throttledNow, setInterval, getNewVisibleInterval]);

    const handleNowButtonClick = useCallback(() => {
        setCursorTime();
    }, [setCursorTime]);

    const left = Math.max(percentageOfInterval(throttledNow, timelineInterval), 0);
    const nowIsWithinInterval = isWithinInterval(throttledNow, timelineInterval);
    const isFuture = left <= 0;
    const isPast = left >= 1;

    return (
        <div
            data-testid="TimelineNowIndicator"
            className={classNames('TimelineNowIndicator', {
                'TimelineNowIndicator--past': isPast,
                'TimelineNowIndicator--future': isFuture,
            })}
        >
            {isFuture || isPast ? (
                <Button
                    className="TimelineNowIndicator__button"
                    onClick={handleGoToNowClick}
                    text="Back to Now"
                    startIcon={isFuture && 'back'}
                    endIcon={isPast && 'goto'}
                    variant="compact"
                />
            ) : null}
            <div className="TimelineNowIndicator__background" style={{ left: `${left * 100}%` }}>
                {nowIsWithinInterval ? (
                    <button
                        data-testid="timeline-now-button"
                        onClick={handleNowButtonClick}
                        className="TimelineNowIndicator__label"
                    >
                        Now
                    </button>
                ) : null}
            </div>
        </div>
    );
}
